var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"my-6"},[_vm._v(_vm._s(_vm.$t("posts.footer.browse")))]),_c('PostCategories',{attrs:{"extended":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }